"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePartSize = void 0;
const constants_1 = require("../../../utils/constants");
const calculatePartSize = (totalSize) => {
    if (!totalSize) {
        return constants_1.DEFAULT_PART_SIZE;
    }
    let partSize = constants_1.DEFAULT_PART_SIZE;
    let partsCount = Math.ceil(totalSize / partSize);
    while (partsCount > constants_1.MAX_PARTS_COUNT) {
        partSize *= 2;
        partsCount = Math.ceil(totalSize / partSize);
    }
    return partSize;
};
exports.calculatePartSize = calculatePartSize;
